module.exports = __webpack_public_path__ + "static/media/bottom_infographic_desktop.fd3feeb9.webp";